<template>
  <v-container>
    <v-row align="center" style="height: 550px">
      <v-col align="center">
        <v-card max-width="1100" hover elevation="5" width="400">
          <v-card-title> Вход для экспертов </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="username"
              label="Логин или электронная почта"
              type="text"
            />
            <v-text-field v-model="password" label="Пароль" type="password" />
            <div class="mt-12 text-center" v-if="message">
              <h3 class="red--text">
                {{ message }}
              </h3>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click.stop="onSignIn"
              :disabled="isLoading"
              :loading="isLoading"
              >Войти</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ACTIONS, GETTERS } from "@/store";

export default {
  data: () => ({
    username: "",
    password: "",
  }),

  computed: {
    ...mapGetters({
      isLoading: GETTERS.IS_LOADING,
      user: GETTERS.USER_DATA,
      isAuthenticated: GETTERS.USER_IS_AUTHENTICATED,
    }),
    message() {
      return this.user.message || "";
    },
  },

  methods: {
    ...mapActions({ signin: ACTIONS.USER_SIGNIN }),

    onSignIn() {
      this.signin({ username: this.username, password: this.password });
    },
  },
  watch: {
    isAuthenticated(value) {
      if (value) {
        this.$router.push({ name: "Home" });
      }
    },
  },
};
</script>
